gz-text {
  width: 250px;
  margin-top: 5px;
}
